import { render } from "./glob-label.vue?vue&type=template&id=7d231d88&scoped=true"
import script from "./glob-label.vue?vue&type=script&lang=js"
export * from "./glob-label.vue?vue&type=script&lang=js"

import "./glob-label.vue?vue&type=style&index=0&id=7d231d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d231d88"]])

export default __exports__